import { StreamData } from 'types/streamData'
import WidgetType from 'enums/WidgetType'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const reblogsResolver: FieldResolver = (metadata: Metadata) => {
  const widgetType = metadata.getWidgetType()
  let reblogs
  if (widgetType && widgetType === WidgetType.SOCIAL_WEB_POPULAR_POSTS) {
    reblogs = metadata.getReblogs()
  }

  return { reblogs } as StreamData
}

export default reblogsResolver
